import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from "@/components/ui/sheet";
import { AlertTriangle } from "lucide-react";
import { formatCNPJ, formatDateTime } from "@/lib/ocorenApi";
import { NFTimeline } from "@/components/NFTimeline";

const Row = ({ label, value, mono = false, badge }) => (
  <div className="flex items-start justify-between gap-6 py-3 border-b border-[#E4E4E7] last:border-b-0">
    <div className="text-[11px] uppercase tracking-[0.15em] text-[#52525B] font-semibold w-40 shrink-0">
      {label}
    </div>
    <div
      className={`text-sm text-[#09090B] text-right break-words flex items-center justify-end gap-2 ${
        mono ? "font-mono-data" : ""
      }`}
    >
      <span>{value || "—"}</span>
      {badge}
    </div>
  </div>
);

export const OcorrenciaDrawer = ({ mov, open, onOpenChange }) => {
  const truncadaBadge = mov?.descricao_truncada ? (
    <span
      data-testid="drawer-truncada-badge"
      className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.1em] px-1.5 py-0.5 rounded-sm bg-amber-50 border border-amber-200 text-amber-800 font-bold"
      title="Descrição truncada no arquivo origem"
    >
      <AlertTriangle size={10} />
      truncada
    </span>
  ) : null;

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        data-testid="ocorrencia-drawer"
        className="w-full sm:max-w-lg bg-white overflow-y-auto"
      >
        <SheetHeader>
          <SheetTitle className="font-heading text-2xl tracking-tight">
            Detalhes da Ocorrência
          </SheetTitle>
          <SheetDescription>
            Movimentação registrada via EDI OCOREN
          </SheetDescription>
        </SheetHeader>

        {mov && (
          <>
            <div className="mt-6">
              <Row label="Arquivo" value={mov.nome_arquivo} />
              <Row label="Tipo de Registro" value={mov.tipo_registro} mono />
              <Row label="Transportadora" value={mov.nome_transportadora} />
              <Row
                label="CNPJ Transportadora"
                value={formatCNPJ(mov.cnpj_transportadora)}
                mono
              />
              <Row
                label="CNPJ Cliente"
                value={formatCNPJ(mov.cnpj_cliente)}
                mono
              />
              <Row label="Série" value={mov.serie} mono />
              <Row label="Número NF" value={mov.numero_nota} mono />
              <Row
                label="Data Ocorrência"
                value={formatDateTime(mov.data_ocorrencia)}
                mono
              />
              <Row label="Código" value={mov.codigo_ocorrencia} mono />
              <Row
                label="Descrição"
                value={mov.descricao_ocorrencia}
                badge={truncadaBadge}
              />
            </div>

            {/* Linha do tempo da mesma NF */}
            <div className="mt-8 pt-5 border-t border-[#E4E4E7]">
              <NFTimeline
                numero_nota={mov.numero_nota}
                cnpj_cliente={mov.cnpj_cliente}
              />
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};

export default OcorrenciaDrawer;
